import { useState } from 'react';
import classNames from 'classnames';
import Button from 'components/partials/button/button';
import ResponsiveWrapper from 'components/shared/others/responsive-wrapper/responsive-wrapper';
import Icons from 'assets/icons';

interface SeeMoreButtonProps {
  onClick: () => void;
  showAll?: boolean;
}

const SeeMoreButton = ({
  onClick,
  showAll = false,
}: SeeMoreButtonProps): React.JSX.Element => {
  const [buttonText, setButtonText] = useState<string>('See more');

  return (
    <ResponsiveWrapper>
      <Button
        variant="reserve-outlined"
        className="mt-10"
        iconAfter={
          <Icons.DoubleArrow
            className={classNames({
              '-rotate-90': showAll,
              'rotate-90': !showAll,
            })}
          />
        }
        onClick={() => {
          onClick();
          setButtonText(showAll ? 'See more' : 'See less');
        }}
      >
        {buttonText}
      </Button>
    </ResponsiveWrapper>
  );
};

export default SeeMoreButton;
